import { GraphQlClient, Lodash } from '@intelipost-js/secure-providers';
import { ScToast } from '@intelipost-js/secure-components';

export default {
  setWindowEdit({ commit }, dataToEdit) {
    const {
      created,
      date_range,
      modification,
      name,
      ...params
    } = dataToEdit;

    commit('toggleLoading', true);
    return GraphQlClient.mutation(
      `mutation(
        $id: Int,
        $lead_time: Int,
        $adjustment_percentage: Float,
        $enabled: Boolean
      ) {
        updateCapacityWindow(
          id: $id
          lead_time: $lead_time
          adjustment_percentage: $adjustment_percentage
          enabled: $enabled
          ){
            ok
          }
        }
      `,
      params,
    )
      .then(() => {
        ScToast.success('Janela editada com sucesso');
        commit('toggleLoading', false);
        commit('setWindowList', {});
      })
      .catch(() => commit('toggleLoading', false));
  },
  getWindowDetails({ commit }, idOfWindow) {
    commit('toggleLoading', true);
    return GraphQlClient.query(
      `query ($id: Int){
        capacitySchemaByWindowId (id: $id) {
          name,
          origin_zipcode,
          enabled,
          id,
          destination_zipcodes {
            start,
            end,
          }
          source {
            type,
            name,
          }
          window {
            id,
            name,
            lead_time,
            adjustment_percentage,
            enabled,
            created,
            date_range {
              start,
              end,
            },
            modification {
              date_time,
              author
            }
          }
        }
      }`,
      { id: idOfWindow },
    )
      .then((response) => {
        commit('toggleLoading', false);
        const { data } = response || {};
        const { capacitySchemaByWindowId } = data || {};
        commit('setWindowDetails', capacitySchemaByWindowId);
      })
      .catch(() => commit('toggleLoading', false));
  },
  enableWindow({ commit, state }, statusWindow) {
    commit('toggleLoading', true);

    const { id, enabled } = statusWindow;
    const newWindowList = Lodash.cloneDeep(state.windowList);
    const currentWindowIndex = newWindowList.items
      .findIndex(currentWindowItem => currentWindowItem.id === id);
    newWindowList.items[currentWindowIndex].enabled = enabled;
    commit('setWindowList', newWindowList);

    return GraphQlClient.mutation(
      `mutation (
        $id: Int,
        $enabled: Boolean,
      ) {
        updateCapacityWindowEnabled(
          id: $id,
          enabled: $enabled,
        ) {
          ok
        }
      }
    `,
      statusWindow,
    )
      .then(() => {
        commit('toggleLoading', false);
        ScToast.success('Janela editada com sucesso');
      })
      .catch((err) => {
        const newWindowListError = Lodash.cloneDeep(state.windowList);
        newWindowListError.items[currentWindowIndex].enabled = !enabled;
        commit('setWindowList', newWindowListError);
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  getWindows({ commit }, params) {
    const { filters, pagination } = params || {};
    commit('toggleLoading', true);
    return GraphQlClient.query(
      `query (
        $search_by: String,
        $search_value: Int,
        $date_type: String,
        $date_range: CapacityWindowDateRangeQuery,
        $pagination: CapacityWindowPagination,
        $schema_enabled: Boolean
        ) {
        capacityWindows (
          search_by: $search_by,
          search_value: $search_value,
          date_type: $date_type,
          date_range: $date_range,
          schema_enabled: $schema_enabled
          pagination: $pagination ) {
            items {
              id,
              capacity_schema_id,
              name,
              source {
                type,
                name,
              }
              lead_time,
              adjustment_percentage,
              enabled,
              created,
              date_range {
                start,
                end,
              }
            }
            total
          }
        }
      `,
      { ...filters, pagination },
    )
      .then((response) => {
        commit('toggleLoading', false);
        const { data } = response || {};
        const { capacityWindows } = data || {};
        commit('setWindowList', capacityWindows);

        return Promise.resolve({});
      })
      .catch(() => commit('toggleLoading', false));
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-capacity-management/features/window/store/actions.js